import React from 'react';
import { Carousel } from 'antd';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { getChildrenToRender } from './utils';

class Banner5 extends React.PureComponent {


  render() {

    console.error("this.props:  ", this.props)
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;
    console.error("tagProps: ", tagProps);
    
    const animType = {
      queue: 'bottom',
      one: {
        y: '+=30',
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
      },
    };
    return (
      <div {...tagProps} {...dataSource.wrapper}>
  <Carousel autoplay style={{marginTop:'120px',height:'500px'}}>
    <div>
      <img height='500' width='100%'src="https://resqj.hjiuye.com/styles/images/about-2.jpg" />
    </div>
   
  </Carousel>
         {/* <div {...dataSource.page}>
   
          <QueueAnim
            key="text"
            type={animType.queue}
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            {...dataSource.childWrapper}
            componentProps={{
              md: dataSource.childWrapper.md,
              xs: dataSource.childWrapper.xs,
            }}
          >
            {dataSource.childWrapper.children.map(getChildrenToRender)}
    
          </QueueAnim>
          <TweenOne animation={animType.one} key="title" {...dataSource.image}>
            <img src={dataSource.image.children} width="100%" alt="img" />
          </TweenOne>
  
        </div> */}
      
   
      </div>
    );
  }
}
export default Banner5;
